<template>
    <div>

        <div class="row margined-bottom">
            <div class="col-md-12">
                <label class="control-label" for="email">Email</label>
                <button
                    type="button"
                    class="btn btn-help-icon"
                    data-bs-toggle="tooltip"
                    data-bs-html="true"
                    title="You can search users with name or email"
                    data-bs-container="body"
                    data-bs-placement="right"
                >?</button>
            </div>
            <div class="col-md-4">
                <input type="hidden" id="user_id" name="user_id" v-model="user.id">
                <user-search-component
                    v-bind:field="field"
                    v-bind:role="role"
                    v-bind:trigger-text="''"
                    v-bind:as-mail-input="true"
                    v-bind:default-user-id="parseInt(user.user_id)"
                    v-bind:default-query="user.email"
                ></user-search-component>
                <validation-error :errors="errors.email" :class="'validation-alert'"></validation-error>
            </div>
        </div>


        <div class="row margined-bottom">
            <div class="col-md-12">
                <label for="first_name">First Name</label>
            </div>
            <div class="col-md-4">
                <input type="text" id="first_name" name="first_name" v-model="user.first_name" :disabled="!isFormEnabled" required maxlength="255" minlength="1">
                <validation-error :errors="errors.first_name" :class="'validation-alert'"></validation-error>
            </div>
        </div>


        <div class="row margined-bottom">
            <div class="col-md-12">
                <label for="last_name">Last Name</label>
            </div>
            <div class="col-md-4">
                <input type="text" id="last_name" name="last_name" v-model="user.last_name" :disabled="!isFormEnabled" required maxlength="255" minlength="1">
                <validation-error :errors="errors.last_name" :class="'validation-alert'"></validation-error>
            </div>
        </div>

        <div class="row margined-bottom">
            <div class="col-md-12">
                <label for="phone_number">Phone Number</label>
            </div>
            <div class="col-md-4">
                <input type="number" id="phone_number" name="phone" v-model="user.phone" :disabled="!isFormEnabled" required>
                <validation-error :errors="errors.phone" :class="'validation-alert'"></validation-error>
            </div>
        </div>


        <div class="row margined-bottom" v-if="isCompanyForm">
            <div class="col-md-12">
                <label>Choose Company</label>
            </div>
            <div class="col-md-4">
                <input type="hidden" name="company_id" v-model="selectedCompany.id">

                <multiselect
                    v-model="selectedCompany"
                    :options="companies"
                    track-by="name"
                    label="name"
                    placeholder="Any Company"
                    :searchable="true"
                    @select="getInventories"
                    :loading="loadingCompanies"
                    :internal-search="true"
                    :allow-empty="true"
                    :disabled="!isFormEnabled"
                ></multiselect>
                <validation-error :errors="errors.company_id" :class="'validation-alert'"></validation-error>

            </div>
        </div>


        <div class="row margined-bottom" v-if="isCompanyForm && selectedCompany.id">
            <div class="col-md-12">
                <label>Accessible Offices</label>
            </div>
            <div class="col-md-4">
                <input type="hidden" name="inventory_id" v-if="selectedInventory" v-model="selectedInventory.id">

                <multiselect
                    v-model="selectedInventory"
                    :options="inventories"
                    track-by="fullName"
                    label="fullName"
                    placeholder="Any Inventory"
                    :searchable="true"
                    :loading="loadingInventories"
                    :internal-search="true"
                    :allow-empty="true"
                ></multiselect>

                <validation-error :errors="errors.inventory_id" :class="'validation-alert'"></validation-error>

            </div>
        </div>



        <div class="row margined-bottom">
            <div class="col-md-12">
                <label for="tag_number">Tag</label>
            </div>
            <div class="col-md-4">
                <div class="input-group"  v-if="!user.tags || user.tags.length < 1">
                    <input :minlength="tagNumberLengths.min" :maxlength="tagNumberLengths.max"  type="text" name="tag_number" id="tag_number" value="" class="tag-input form-control" :disabled="!isFormEnabled" required>
                </div>
                <div v-for="tag in user.tags">
                    <div class="input-group tag_number-container">
                        <input :minlength="tagNumberLengths.min" :maxlength="tagNumberLengths.max"  type="text" v-bind:value="tag.tag_number" class="tag-input tag_number form-control" disabled="disabled">
                        <input type="hidden"  v-bind:value="tag.tag_number">
                    </div>
                </div>

                <validation-error :errors="errors.tag_number" :class="'validation-alert'"></validation-error>
            </div>
        </div>

        <div class="row margined-bottom">
            <div class="col-md-4">
                <form-sender-button
                    v-bind:alert-text="senderWarning"
                    v-bind:form-id="'new-visitor-form'"
                    v-bind:btn-class="'btn btn-light'"
                ></form-sender-button>
                <form-cancellation-button
                    v-bind:btn-text="'Clear Form'"
                    v-bind:btn-class="'btn btn-light'"
                ></form-cancellation-button>
                <a type="button" class="btn btn-danger float-end" v-bind:href="previousUrl"> Cancel </a>
            </div>
        </div>

    </div>
</template>

<script>
import {EventBus} from '@/V3/EventBus.js';
import Companies from "../Services/Companies";
import Multiselect from 'vue-multiselect';

export default {
        name: "NewVisitorAccessFormComponent",
        components: {
            Multiselect
        },
        props: {
            isCompanyForm: {
                type: Boolean,
                default: false,
            },
            centreId: {
                type: Number,
            },
            errors: {
                type: [Object, Array],
            },
            old: {
                type: [Object, Array],
            },
            field: {
                type: [Object, Array],
            },
            role: {
                type: [Object, Array],
            },
            previousUrl: {
                type: String,
                default: ""
            },
            defaultUserId: {
                type: Number,
                default: null,
            },
            senderWarning: {
                type: String,
                default: "Are you sure?"
            },
            tagNumberLengths: {
                type: Object,
            },
            vendor: {
                type: String,
            }
        },
        data: function() {
            return {
                user: {
                    tags: [],
                    ...this.old
                },
                isEmailDisabled: false,
                companies: [],
                inventories: [],
                loadingCompanies: false,
                loadingInventories: false,
                selectedCompany: {
                    id: null,
                },
                selectedInventory: {
                    id: null,
                },
                isFormEnabled: false,
            }
        },
        created() {
            this.user.full_name = this.placeholder;
            EventBus.on('user-selected', this.userSelected);
            EventBus.on('all-forms-cancelled', this.clearForm);
            EventBus.on('valid-email-address-entered', this.enableForm);

            if (this.isCompanyForm) {
                this.getCompanies();
            }
        },
        methods: {
            enableForm: function() {
                this.isFormEnabled = true;
            },

            userSelected: function (user) {
                user.tags = user.tags.filter((tag) => {
                    return tag.vendor === this.vendor && (!tag.centre_id || tag.centre_id === this.centreId);
                });
                this.user = user;
                this.isEmailDisabled = true;
                this.enableForm();
            },

            getCompanies: function () {
                this.loadingCompanies = true;
                Companies.list(this.centreId).then((companies) => {
                    this.companies = companies;
                    this.loadingCompanies = false;

                    if (this.old.company_id) {
                        this.selectedCompany = this.companies.find((company) => {return company.id === parseInt(this.old.company_id); });
                        this.getInventories(this.selectedCompany);
                    }

                });
            },

            getInventories: function (company) {
                this.loadingInventories = true;
                this.selectedInventory = null;
                Companies.getInventoriesForActiveBookings(this.centreId, company.id).then((inventories) => {
                    let inventoryList = Object.values(inventories);

                    inventoryList = inventoryList.map((inventory) => {
                        inventory.fullName = inventory.name + " - " + inventory.product.name;
                        return inventory;
                    });

                    this.inventories = inventoryList;

                    this.loadingInventories = false;

                    if(this.old.inventory_id) {
                        this.selectedInventory = this.inventories.find((inventory) => { return inventory.id === parseInt(this.old.inventory_id); });
                    }

                })
            },

            clearForm: function () {
                this.user = {
                    tags: []
                };
                this.selectedCompany = false;
                this.selectedInventory = false;
            }
        }
    }
</script>

<style scoped>
    input {
        width: 100%;
    }

    .tag_number-container {
        margin-bottom: 1rem;
    }

    .tag_number-container > .tag_number {
        border: 0;
        box-shadow: none;
    }
</style>
